import { Model } from ".";

export default class OutboundFreightReport extends Model {
	get singularNoun() {
		return "outbound freight report";
	}

	resource() {
		return "reports/warehouse/outbound-freight";
	}
}
